// extracted by mini-css-extract-plugin
export default {"container":"HorizontalGallery-module--container--F2dpA","centerItem":"HorizontalGallery-module--centerItem--UUBt8"};